import React, {ReactNode} from 'react';
import {NavLink} from 'react-router-dom';
import {useLocation} from 'react-router';
import classNames from 'classnames';
import {can} from '../../../_common/components/Permissions';
import {checkIsActive} from '../../../../../_metronic/_helpers';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import styles from './styles.module.scss';
import Divider from '../Divider';

interface AsideMenuLinkProps {
  pathname: string,
  icon: string,
  label: ReactNode,
  isSubSection: boolean
  subject?: string,
}

const AsideMenuLink = ({
                         pathname,
                         subject,
                         icon,
                         label,
                         isSubSection
                       }: AsideMenuLinkProps) => {
  const location = useLocation();
  const isActive = checkIsActive(location, pathname);
  const condition = subject ? can(T.VIEW, subject) : isActive;

  return condition
    ? (
      <>
        {subject === S.PRICE_CATALOG_PAGE && <Divider customClassNames={'my-8'}/>}
        <li className={classNames(styles.item)}>
          <NavLink
            className={classNames(
              styles.link,
              isActive && styles.activeLink,
              isSubSection && styles.disabled
            )}
            to={pathname}>
            <img
              src={`../../media/common/${icon}`}
              alt="icon" className={styles.icon}
            />
            <div className={classNames(
              'menu-text',
              styles.linkText,
              isSubSection && styles.smallText
            )}>
              {label}
            </div>
          </NavLink>
        </li>
      </>
    )
    : null;
};

export default AsideMenuLink;
